// Typelizer digest 0b27c1ae691049d2d6d644cdfa9d07b2
//
// DO NOT MODIFY: This file was automatically generated by Typelizer.
import type { RouteDefinition, RouteOptions } from '../../runtime'
import { buildUrl } from '../../runtime'

export default {
  /** GET /auth/google_oauth2/callback */
  google: (options?: RouteOptions): RouteDefinition<'get'> => ({
    url: buildUrl('/auth/google_oauth2/callback', {}, options),
    method: 'get',
  }),
}
